import { Clips } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  Clips,
  React
};